import { lazy } from 'react';
import { createRoute } from '@tanstack/react-router';
import { adminRoute } from './_admin';

// Code splitting: Lazy load PhotosPage to reduce initial bundle size
const PhotosPage = lazy(() => import('@/pages/admin/PhotosPage'));

/**
 * Admin photos list route - /admin/photos
 * Shows paginated list of all photos across all users
 */
export const adminPhotosRoute = createRoute({
  getParentRoute: () => adminRoute,
  path: 'photos',
  component: PhotosPage,
});

// Backward compatibility
export const Route = adminPhotosRoute;
